import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { first, map, mergeMap, tap } from 'rxjs/operators';
import { ConfigService } from '../../../config/config.service';
import { ClientService } from '../../shared/client/client.service';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  /**
   *
   * @param configService
   * @param http
   * @param clientService
   */
  constructor(
    private configService: ConfigService,
    private http: HttpClient,
    private clientService: ClientService
  ) { }

  /**
   * Export globalPDF
   */
  public exportCalendarBillings(client) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        let url = config.apiPoint + config.getClientBillingsExport;
        return this.http.get(url.replace('{client}', client.id), { responseType: 'arraybuffer' }).pipe(
          tap(res => {
            let blob = new Blob([res], { type: 'application/pdf' });
            const nav = (window.navigator as any);
            if (nav.msSaveOrOpenBlob) {
              let newUrl = nav.msSaveOrOpenBlob(blob, 'test.pdf');
            } else {
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.setAttribute('download', `export_global.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }));
      })
    );
  }

    public getLeanPayURL(client) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<string>(config.apiPoint + config.getLeanPayURL.replace("{client}", client.id))
      })
    )
  }
}
